import { isFunction } from 'lodash'

import { getIdOrNull, isNonEmptyArray, validateString } from '..'
import { ValidationFields } from '../validators'

/** @enum {string} */
export const SectionGroupProperties = Object.freeze({
  NAME: ValidationFields.NAME,
  SECTIONS: ValidationFields.SECTIONS,
  SECTORS: ValidationFields.SECTORS,
  INSTITUTION: ValidationFields.INSTITUTION
})

export const SectionGroupValidators = Object.freeze({
  [SectionGroupProperties.NAME]: group => validateString(group.name, { notEmpty: true }),
  [SectionGroupProperties.SECTIONS]: group => isNonEmptyArray(group.sections),
  [SectionGroupProperties.SECTORS]: group => isNonEmptyArray(group.sectors) || getIdOrNull(group.institution) !== null,
  [SectionGroupProperties.INSTITUTION]: group => getIdOrNull(group.institution) !== null || isNonEmptyArray(group.sectors)
})

export const getName = group => group[SectionGroupProperties.NAME]
export const getSections = group => group[SectionGroupProperties.SECTIONS]
export const getSectors = group => group[SectionGroupProperties.SECTORS]
export const getInstitution = group => group[SectionGroupProperties.INSTITUTION]

export const findSection = (group, section) => getSections(group).map(getIdOrNull).find(id => id === getIdOrNull(section)) ?? null
export const includeSection = (group, section) => findSection(group, section) !== null

export class SectionGroup {
  static toDTO = (object) => new this(object).toRequestBody()

  constructor ({ id = -1, name = null, sections = [], sectors = [], institution = null } = {}) {
    this.id = id
    this.name = name
    this.sections = sections
    this.sectors = sectors
    this.institution = institution
  }

  toRequestBody = () => {
    const body = {}

    Object.entries(this).forEach(([property, value]) => {
      if (property === SectionGroupProperties.NAME) {
        body[property] = value
      } else if (isNonEmptyArray(value)) {
        body[property] = value.map(getIdOrNull)
      } else if (!isFunction(value)) {
        body[property] = getIdOrNull(value)
      }
    })

    if (isNonEmptyArray(body.sectors)) {
      delete body.institution
    } else {
      delete body.sectors
    }

    return body
  }
}
